import EditDelivery from './AutoDeliveryDetailsPages/EditDelivery/EditDelivery';

const AutoDeliveryAsapPage = () => {
    return <EditDelivery isAsap />;
};

export default AutoDeliveryAsapPage;
